export enum StandardCallType {
  DISCOVERY = "DISCOVERY",
  DEMO = "DEMO",
  INTERVIEW = "INTERVIEW",
  CLOSING = "CLOSING",
}
